<template>
  <section class="co-bg-striped">
    <div class="co-container-md mx-auto px-4 py-20">
      <h2 class="co-display-7 mb-12 text-center tracking-[.15em]">
        テックアカデミーとは
      </h2>
      <div class="flex flex-wrap">
        <div class="lg:basis-full">
          <div class="flex flex-wrap items-center justify-center">
            <div class="basis-full pb-4 text-center lg:basis-1/4 lg:pb-0">
              <img
                class="te-logo-teckacademy mx-auto px-2"
                src="~/assets/images/Te/TeJob/Index/What/logo-blue-bertical.svg"
                alt="テックアカデミー"
              >
            </div>
            <div class="lg:basis-3/4">
              <h3 class="co-display-10 mb-4 text-center lg:text-left">
                現役エンジニアから学べる
                <br class="block lg:hidden">
                オンラインに特化したスクール
              </h3>
              <p>
                プログラミングやアプリ開発、Webサイトの制作を学べるオンラインスクール。
                <br class="hidden lg:block">
                独自の学習システムを使い、現役のプロである
                <span class="font-bold">
                  選抜されたメンター
                </span>
                が手厚くサポートすることで、
                <br class="hidden lg:block">
                受講生の学習時の挫折をなくします。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.te-logo-teckacademy {
  width: 25%;
}

@media (min-width: 992px) {
  .te-logo-teckacademy {
    width: 75%;
  }
}
</style>
